var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('li',{staticClass:"ebx-result-suggestion ebx-suggestion",class:{'ebx-result-suggestion--selected': _vm.selected, 'ebx-suggestion--selected': _vm.selected}},[_vm._t("result")],2)}
var staticRenderFns = []

export { render, staticRenderFns }